export default __webpack_public_path__ + "static/media/R16.2c517bc9.png";